import { useQuery, UseQueryResult, useQueryClient } from "@tanstack/react-query"
import { isIOSNativeApp, isAndroidNativeApp } from "#/lib/carrot-api/MobileNativeClient"

export type MobileAppStatus = {
  isIOS: boolean
  isAndroid: boolean
}

const getMobileAppStatusCacheKey: string[] = ["getMobileAppStatus"]

// These hooks exist so that corresponding contentful attributes can be toggled with the dynamic content tool.
export function useMobileAppStatus(): UseQueryResult<MobileAppStatus> {
  return useQuery<MobileAppStatus>(getMobileAppStatusCacheKey, () => ({
    isIOS: isIOSNativeApp(),
    isAndroid: isAndroidNativeApp()
  }))
}

export function useCreateMobileAppStatusOverride(): (conditions: MobileAppStatus) => void {
  const queryClient = useQueryClient()
  return (conditions: MobileAppStatus) => {
    queryClient.setQueryDefaults(getMobileAppStatusCacheKey, { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData(getMobileAppStatusCacheKey, conditions)
  }
}
